import get from 'lodash/get';
import merge from 'lodash/merge';
import _values from 'lodash/values';
import { formValueSelector as _formValueSelector, getFormValues as _getFormValues, getFormInitialValues as _getFormInitialValues, getFormSyncErrors as _getFormSyncErrors, getFormAsyncErrors as _getFormAsyncErrors,
// getFormSyncWarnings as _getFormSyncWarnings,   // Not yet shipped in redux-form-6
getFormSubmitErrors as _getFormSubmitErrors, getFormNames as _getFormNames, isDirty as _isDirty, isPristine as _isPristine, isValid as _isValid, isInvalid as _isInvalid, isSubmitting as _isSubmitting, hasSubmitSucceeded as _hasSubmitSucceeded, hasSubmitFailed as _hasSubmitFailed } from 'redux-form';
import { createSelector } from 'reselect';
import { nest } from '../helpers';
// $FlowFixMe[missing-local-annot]
const passProps = (state, props) => props;
const selectFormState = state => state.gandiForm;

/**
 * Wrapped selectors over redux-form contextualized by a form name.
 */

export const formValueSelector = form =>
// $FlowFixMe[incompatible-exact]
_formValueSelector(form, selectFormState);
export const getFormValues = (form
// $FlowFixMe[incompatible-exact]
// $FlowFixMe[deprecated-type]
) =>
// $FlowFixMe[incompatible-exact]
_getFormValues(form, selectFormState);
export const getFormInitialValues = (form
// $FlowFixMe[incompatible-exact]
// $FlowFixMe[deprecated-type]
) =>
// $FlowFixMe[incompatible-exact]
_getFormInitialValues(form, selectFormState);
export const getFormSyncErrors = (form
// $FlowFixMe[incompatible-exact]
// $FlowFixMe[deprecated-type]
) =>
// $FlowFixMe[incompatible-exact]
_getFormSyncErrors(form, selectFormState);
export const getFormAsyncErrors = (form
// $FlowFixMe[incompatible-exact]
// $FlowFixMe[deprecated-type]
) =>
// $FlowFixMe[incompatible-exact]
_getFormAsyncErrors(form, selectFormState);

// export const getFormSyncWarnings = (form: string) => _getFormSyncWarnings(form, selectFormState);

export const getFormSubmitErrors = (form
// $FlowFixMe[incompatible-exact]
// $FlowFixMe[deprecated-type]
) =>
// $FlowFixMe[incompatible-exact]
_getFormSubmitErrors(form, selectFormState);

// $FlowFixMe[deprecated-type]
export const getFormNames = () => _getFormNames(selectFormState);
export const isDirty = (form
// $FlowFixMe[incompatible-exact]
// $FlowFixMe[deprecated-type]
) =>
// $FlowFixMe[incompatible-exact]
_isDirty(form, selectFormState);
export const isPristine = (form
// $FlowFixMe[incompatible-exact]
// $FlowFixMe[deprecated-type]
) =>
// $FlowFixMe[incompatible-exact]
_isPristine(form, selectFormState);
export const isValid = (form
// $FlowFixMe[incompatible-exact]
// $FlowFixMe[deprecated-type]
) =>
// $FlowFixMe[incompatible-exact]
_isValid(form, selectFormState);
export const isInvalid = (form
// $FlowFixMe[incompatible-exact]
// $FlowFixMe[deprecated-type]
) =>
// $FlowFixMe[incompatible-exact]
_isInvalid(form, selectFormState);
export const isSubmitting = (form
// $FlowFixMe[incompatible-exact]
// $FlowFixMe[deprecated-type]
) =>
// $FlowFixMe[incompatible-exact]
_isSubmitting(form, selectFormState);
export const hasSubmitSucceeded = (form
// $FlowFixMe[incompatible-exact]
// $FlowFixMe[deprecated-type]
) =>
// $FlowFixMe[incompatible-exact]
_hasSubmitSucceeded(form, selectFormState);
export const hasSubmitFailed = (form
// $FlowFixMe[incompatible-exact]
// $FlowFixMe[deprecated-type]
) =>
// $FlowFixMe[incompatible-exact]
_hasSubmitFailed(form, selectFormState);

/**
 * Custom selectors to complete the official ones...
 */

/**
 * Return registered fields of a form.
 */
export const selectRegisteredFields = createSelector(passProps, selectFormState,
// $FlowFixMe[unclear-type]
(props, formState) => get(formState, `${props.form}.registeredFields`, []));

/**
 * Return all values of a form.
 */
export const selectFormValues = createSelector(passProps, selectFormState,
// $FlowFixMe[unclear-type]
(props, formState) => get(formState, `${props.form}.values`, {}));

/**
 * Return values of only registered fields of a form.
 * Redux-form doesn't allow out of the box a selector to retrieve only
 * registered fields.
 * See https://github.com/erikras/redux-form/issues/2368.
 */
export const selectRegisteredFieldsValues = createSelector(selectRegisteredFields, selectFormValues, (registeredFields, values) => _values(registeredFields).reduce((acc, field) =>
// get the value by using lodash/get to go in objects depth,
// nest values to retrieve the object struct,
// merge in depth to the accumulator
merge(nest(field.name, get(values, field.name)), acc), {}));